// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"60","screenBreakPointsXl":"840px"};